import { ToggleButton, PDFViewer } from '@/shared/ui/components';
import { DEVICE } from '@/shared/config';
import _ from 'lodash';
import { useDeviceManualsPdf } from './useDeviceManualsPdf';
import type { DeviceManualsPdfProps } from './deviceManualsPdf.types';

/**
 * Renders a device manual PDF together with a device category switcher. Only mounts when the sub-tab is active, lists a toggle button per category from the hook and shows the Bioflux or Biotres document depending on the selected category.
 *
 * @param isActive - Whether this manual sub-tab is currently selected.
 * @param data - Manual urls keyed by device, holding bioflux and biotres entries.
 * @returns The category switcher with the PDF viewer, or a falsy value when inactive.
 */
const DeviceManualsPdf = ({ isActive, data }: DeviceManualsPdfProps) => {
  const { categoryList, state, onChange } = useDeviceManualsPdf();

  return (
    isActive && (
      <div className="support-tab instructions-for-use">
        <div className="support-tab__body">
          <div className="category-list">
            {_.map(categoryList.current, (item, index) => (
              <ToggleButton
                key={index}
                className={index > 0 ? 'ml3' : ''}
                name="category"
                data={item}
                isActive={state.category === item.value}
                onClick={onChange}
              />
            ))}
          </div>
          <PDFViewer url={state.category === DEVICE.BIOFLUX ? data?.bioflux : data?.biotres} />
        </div>
      </div>
    )
  );
};

export default DeviceManualsPdf;
